import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=ddb8f58e&scoped=true"
import script from "./activityDetail.vue?vue&type=script&lang=js"
export * from "./activityDetail.vue?vue&type=script&lang=js"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=ddb8f58e&prod&lang=less&scoped=true"
import style1 from "./activityDetail.vue?vue&type=style&index=1&id=ddb8f58e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8f58e",
  null
  
)

export default component.exports